import { makeStyles } from '@material-ui/core/styles'
import { transition } from '../../../shared/style-settings'
import { createStyles, Theme, alpha } from '@material-ui/core'

export const useAccountSideMenuStyle = makeStyles((theme: Theme) =>
  createStyles({
    sideMenu: {
      margin: 0,
      padding: 0,
      textAlign: 'left',
      position: 'sticky',
      top: theme.spacing(10),
      '& .sideMenuTitle': {
        fontSize: '1.5rem',
        fontWeight: 700,
        color: theme.palette.primary.main,
        marginBottom: theme.spacing(3),
        paddingBottom: theme.spacing(2),
        borderBottom: `2px solid ${theme.palette.primary.main}`,
      },
    },
    sideMenuHolder: {
      margin: 0,
      padding: 0,
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },
    sideMenuItem: {
      listStyle: 'none',
      marginBottom: theme.spacing(0.5),
      '& > a': {
        textDecoration: 'none',
        color: theme.palette.grey[600],
        fontWeight: 600,
        fontSize: '0.9375rem',
        display: 'block',
        padding: theme.spacing(1.5, 2),
        borderRadius: theme.shape.borderRadius * 2,
        transition: transition,
        '&:hover': {
          backgroundColor: alpha(theme.palette.primary.main, 0.06),
          color: theme.palette.primary.main,
          transform: 'translateX(4px)',
        },
      },
    },
    active: {
      '&&': {
        backgroundColor: alpha(theme.palette.primary.main, 0.12),
        color: theme.palette.primary.main,
        fontWeight: 600,
        borderLeft: `3px solid ${theme.palette.primary.main}`,
        paddingLeft: theme.spacing(1.75),
      },
    },
    selectHolder: {
      display: 'block',
      margin: theme.spacing(2, 0),
      [theme.breakpoints.up('md')]: {
        display: 'none',
      },
    },
    select: {
      display: 'block',
      borderRadius: theme.shape.borderRadius * 2,
      position: 'relative',
      border: `1px solid ${theme.palette.divider}`,
      fontSize: '0.9375rem',
      padding: theme.spacing(1.5, 3, 1.5, 2),
      fontWeight: 500,
      backgroundColor: theme.palette.background.paper,
      transition: transition,
      width: '100%',
      '&:hover': {
        borderColor: theme.palette.primary.main,
      },
      '&:focus': {
        outline: 'none',
        borderColor: theme.palette.primary.main,
        boxShadow: `0 0 0 3px ${theme.palette.primary.main}20`,
      },
      '& select': {
        '&:focus': {
          background: 'none !important',
        },
      },
    },
  })
)
